import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal, PopupModal } from "../Components";

import { MdOutlineEdit } from "react-icons/md";
import { FormParser } from "../Components";
import Masters from "../Components/masters.json";
import { FileManager } from "../Components/FileManager";
import { Modal } from "react-bootstrap";
import axiosConfig from "../Service/axiosConfig";

const Settings = () => {
  return (
    <>
      <div>
        <h3>setting page</h3>
      </div>
    </>
  );
};

export { Settings };
